export default __webpack_public_path__ + "media/zurb/img/bryan/fav-posts/ab_tests_vs_multivariate_concept_testing-6ed0629c193b49b5cf8dcc316a13b932.png";